<template>
	<div>
		<div v-if="!inApp">
			<form
				method="post"
				class="loginForm"
				novalidate
				@submit.prevent="submitLogin($event)"
				data-vv-scope="login"
			>
				<div class="form_input">
					<input
						type="email"
						id="loginForm_email"
						name="username"
						v-validate="'required|email'"
						placeholder="מייל*"
					/>
					<div class="error_tx" v-if="errors.first('username')">
						{{ errors.first("username") }}
					</div>
				</div>
				<div class="form_input">
					<input
						type="password"
						id="loginForm_pass"
						name="password"
						v-validate="'required'"
						placeholder="סיסמה*"
					/>
					<div class="error_tx" v-if="errors.first('password')">
						{{ errors.first("password") }}
					</div>
				</div>
				<div class="error_tx">{{ error }}</div>
				<div class="submit_bt ease" :class="{ 'proccessing black': loading }">
					<input type="submit" value="כניסה" />
				</div>
			</form>

			<div class="green_link">
				<a href="javascript:void(0)" @click="openForgotPasswordPopup">שכחתי סיסמה</a>
			</div>

			<div class="social-login">
				<div class="row_or"><span>או</span></div>
				<div class="title_s">כניסה דרך:</div>
				<div class="inline clearfix">
					<div class="right soc_bt soc_g ease">
						<a href="#" @click.prevent="googleLogin">Google <GOOGLE /></a>
					</div>
					<div class="right soc_bt soc_face ease">
						<a href="#" @click.prevent="facebookLogin">Facebook <FACEBOOK /></a>
					</div>
				</div>
			</div>
		</div>

		<div class="sms-login" v-if="inApp">
			<div v-if="step === 1">
				<form
					method="post"
					class="loginFormSMS"
					novalidate
					@submit.prevent="submitLoginSMS($event)"
					data-vv-scope="loginSMS"
				>
					<div class="form_input">
						<div class="login-title">
							אהלן, אנא הזינו מספר טלפון נייד כדי להתחבר לחשבונכם.<br />
							אם במקרה עדיין אין לכם חשבון תועברו לעמוד הרשמה
						</div>
						<input
							type="tel"
							v-validate="{ required: true, regex: /^05\d([-]{0,1})\d{7}$/ }"
							data-validation="phone"
							name="phone_login"
							key="phone_login"
							placeholder="טלפון נייד"
						/>
						<div class="error_tx" v-if="errors.first('phone_login')">
							{{ errors.first("phone_login") }}
						</div>
					</div>
					<div class="error_tx">{{ error2 }}</div>
					<div class="submit_bt ease" :class="{ 'proccessing black': loading2 }">
						<input type="submit" value="שליחת SMS" />
					</div>
				</form>
				<div class="row_or"><span>או</span></div>
				<div class="title_s">כניסה באמצעות מייל וסיסמה:</div>
				<form method="post" class="loginForm" novalidate @submit.prevent="submitLogin($event)">
					<div class="form_input">
						<input
							type="email"
							id="loginForm_email"
							name="username"
							v-validate="'required|email'"
							placeholder="מייל*"
						/>
						<div class="error_tx" v-if="errors.first('username')">
							{{ errors.first("username") }}
						</div>
					</div>
					<div class="form_input">
						<input
							type="password"
							id="loginForm_pass"
							name="password"
							v-validate="'required'"
							placeholder="סיסמה*"
						/>
						<div class="error_tx" v-if="errors.first('password')">
							{{ errors.first("password") }}
						</div>
					</div>
					<div class="error_tx">{{ error }}</div>
					<div class="submit_bt ease" :class="{ 'proccessing black': loading }">
						<input type="submit" value="כניסה" />
					</div>
				</form>
				<div class="green_link">
					<a href="javascript:void(0)" @click="openForgotPasswordPopup">שכחתי סיסמה</a>
				</div>
			</div>
			<div v-if="step === 2">
				<form method="post" class="submitOTP" novalidate @submit.prevent="submitOTP($event)">
					<div class="form_input">
						<div class="login-title">
							רק רצינו לוודא שזה אתם<br />
							אנא הקלידו את הקוד שקיבלתם בSMS
						</div>
						<input
							type="text"
							v-validate="'required|min:6|max:6'"
							name="sms_otp"
							key="sms_otp"
							placeholder="קוד אימות"
						/>
						<div class="error_tx" v-if="errors.first('sms_otp')">
							{{ errors.first("sms_otp") }}
						</div>
					</div>
					<div class="error_tx">{{ error2 }}</div>
					<div class="submit_bt ease" :class="{ 'proccessing black': loading2 }">
						<input type="submit" value="כניסה" />
					</div>
				</form>
			</div>
		</div>
	</div>
</template>

<style>
	.sms-login .login-title {
		margin-bottom: 1em;
	}
</style>

<script>
	import axios from "axios";
	import GOOGLE from "../../assets/img/soc_g.svg";
	import FACEBOOK from "../../assets/img/soc_face.svg";
	export default {
		data() {
			return {
				error: "",
				error2: "",
				loading: false,
				loading2: false,
				inApp: this.$store.state.inApp,
				step: 1
			};
		},
		props: {
			redirectTo: {
				required: false,
				default: "/checkout"
			}
		},
		methods: {
			openForgotPasswordPopup() {
				this.$modal.hide("login-modal");
				this.$modal.show("password-modal");
			},
			googleLogin() {
				var _this = this;
				this.loading = true;
				// Ideally the button should only show up after gapi.client.init finishes, so that this
				// handler won't be called before OAuth is initialized.
				gapi.auth2
					.getAuthInstance()
					.signIn()
					.then(res => {
						if (res) {
							let id_token = res.getAuthResponse().id_token;
							let form = new FormData();
							form.append("id_token", id_token);
							axios({
								method: "POST",
								url: homeUrl + "?googleReg",
								headers: {
									"X-Requested-With": "XMLHttpRequest"
								},
								data: form
							}).then(response => {
								if (response.data.success == "false") {
									_this.error = response.data.errorText;
									_this.loading = false;
									return;
								}
								if (response.data.success == "true") {
									_this.$store.commit("setUserInfo", response.data.userInfo);
									_this.loading = false;
                  _this.send_tag("google");
									_this.$modal.hide("login-modal");
									if (_this.$route.name == "perm_page_new") {
										_this.$router.push("/my-account/permenant");
									}
									if (_this.$route.name == "orderEnter") {
										_this.$router.push(_this.redirectTo);
									}
								}
							});
						}
					});
			},
			facebookLogin() {
				var _this = this;
				this.loading = true;
				FB.login(
					function(response) {
						// Handle the response object, like in statusChangeCallback() in our demo
						// code.

						let token = response.authResponse.accessToken;
						let userId = response.authResponse.userID;
						//  console.log(response);

						let form = new FormData();
						form.append("token", token);
						form.append("userID", userId);
						axios({
							method: "POST",
							url: homeUrl + "?facebookReg",
							headers: {
								"X-Requested-With": "XMLHttpRequest"
							},
							data: form
						}).then(res => {
							if (res.data.success == "false") {
								_this.error = res.data.errorText;
								this.loading = false;
								return;
							}
							if (res.data.success == "true") {
								this.loading = false;
								_this.$store.commit("setUserInfo", res.data.userInfo);
                _this.send_tag("facebook");
								_this.$modal.hide("login-modal");
								if (_this.$route.name == "perm_page_new") {
									_this.$router.push("/my-account/permenant");
								}
								if (_this.$route.name == "orderEnter") {
									_this.$router.push(_this.redirectTo);
								}
							}
						});
					},
					{ scope: "public_profile,email" }
				);
			},
			submitLogin(event) {
				this.$validator.validate("login.*").then(result => {
					if (result) {
						this.loading = true;
						this.$store.state.permOrderLoaded = false;
						axios({
							method: "POST",
							url: homeUrl + "?sendLogin",
							responseType: "html",
							data: $(".loginForm").serialize(),
							headers: {
								"X-Requested-With": "XMLHttpRequest"
							}
						}).then(response => {
              if (response.data.return === "2fa") {
                this.error = response.data.returnTxt;
                window.location.href = "/wp-admin";
                return;
              }

              this.loading = false;
              if (response.data.return === "Error") {
								this.error = response.data.returnTxt;
								return;
							}
							if (response.data.return === "Ok") {
								this.$store.commit("setUserInfo", response.data.userInfo);
								this.send_tag("website");
								this.$modal.hide("login-modal");

								if (this.$route.name === "perm_page_new") {
									this.$router.push("/my-account/permenant");
								}
								if (this.$route.name === "orderEnter") {
									this.$router.push(this.redirectTo);
								}
							}
						});
					}
				});
			},
			submitLoginSMS() {
				this.$validator.validate("loginSMS.*").then(result => {
					if (result) {
						this.loading2 = true;
						this.$store.state.permOrderLoaded = false;
						axios({
							method: "POST",
							url: homeUrl + "?sendLoginSMS",
							responseType: "html",
							data: $(".loginFormSMS").serialize(),
							headers: {
								"X-Requested-With": "XMLHttpRequest"
							}
						}).then(response => {
							this.loading2 = false;
							if (response.data.return === "Error") {
								this.error2 = response.data.returnTxt;
								if (response.data.error === "not_found") {
									this.LoginSmsPhoneNotFound();
								}
							}
							if (response.data.return === "Ok") {
								this.error2 = "";
								this.$data.step = 2;
							}
						});
					}
				});
			},
			submitOTP() {
				this.$validator.validate().then(result => {
					if (result) {
						this.loading2 = true;
						this.$store.state.permOrderLoaded = false;
						axios({
							method: "POST",
							url: homeUrl + "?submitLoginOTP",
							responseType: "html",
							data: $(".submitOTP").serialize(),
							headers: {
								"X-Requested-With": "XMLHttpRequest"
							}
						}).then(response => {
							this.loading2 = false;
							console.log(response);
							if (response.data.return === "Error") {
								this.error2 = response.data.returnTxt;
								return;
							}
							if (response.data.return === "Ok") {
								this.$store.commit("setUserInfo", response.data.userInfo);
								this.send_tag("sms");
								this.$modal.hide("login-modal");

								if (this.$route.name === "perm_page_new") {
									this.$router.push("/my-account/permenant");
								}
								if (this.$route.name === "orderEnter") {
									this.$router.push(this.redirectTo);
								}
							}
						});
					}
				});
			},
			LoginSmsPhoneNotFound() {
				this.$emit("componentEmit", "phoneNotFound");
			},
			send_tag(method) {
				const dataLayer = window.dataLayer || [];
				dataLayer.push({
					event: "login",
					method: method
				});
			}
		},
		components: {
			GOOGLE,
			FACEBOOK
		}
	};
</script>
